package com.trevorwiebe.timesheet.loads.data

import com.trevorwiebe.timesheet.core.domain.TSResult
import com.trevorwiebe.timesheet.mileage.data.toFirebaseData
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.storage.storage
import dev.gitlive.firebase.storage.storageMetadata
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

class LoadFileStorageRepository {
    @OptIn(ExperimentalUuidApi::class)
    suspend fun uploadLoadFile(
        bytes: ByteArray,
        orgId: String,
        filename: String,
    ): TSResult {
        return try {
            val ref = Firebase.storage.reference
                .child("organizations/$orgId/loadFiles/${Uuid.random()}/$filename")
            // Without a content type the file is served as a download instead of opening in the browser.
            ref.putData(bytes.toFirebaseData(), contentTypeFor(filename)?.let { type -> storageMetadata { contentType = type } })
            TSResult(data = ref.getDownloadUrl())
        } catch (e: Exception) {
            TSResult(error = e.message ?: "Failed to upload file")
        }
    }
}

private fun contentTypeFor(filename: String): String? = when (filename.substringAfterLast('.', "").lowercase()) {
    "pdf" -> "application/pdf"
    "jpg", "jpeg" -> "image/jpeg"
    "png" -> "image/png"
    "heic" -> "image/heic"
    "txt" -> "text/plain"
    else -> null
}
